"use strict";
var formValidation = require("../components/formValidation");
var checkboxesGroupValidation = require("../components/checkboxesGroupValidation");
var fieldRequirements = require("../components/fieldRequirements");
var initializeCheckboxAccessibility = require("../components/checkboxAccessibility");
var passwordShow = require("../components/passwordShow");
var debounce = require("lodash/debounce");
var lazyLoading = require("../global/lazyLoading");
var processInclude = require("../util");
var googleRecaptcha = require("../googleRecaptcha");
var recaptchaErrorNotification = require("../components/recaptchaErrorNotification");
const $body = $("body");
const $footerContent = $("#footercontent");
const popupTrigger = $footerContent.data("modal-trigger");
const popupPeriod = $footerContent.data("modal-period");
const seconds = popupPeriod * 1000;
const addressHelpers = require("../checkout/address");
const newsletterValidation = require("../components/newsletterValidation");
const setClearButtonPosition = require("../components/setClearButtonPosition");

/**
 * Retrieves the value of the newsletterPopupShown cookie
 * @returns {boolean} - true if the cookie value is "true", false otherwise
 */
function getNewsletterCookie() {
    var nameEQ = "newsletterPopupShown=";
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];

        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1, cookie.length);
        }

        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length) === "true";
        }
    }

    return false;
}

/**
 * @function
 * @description Function to init the goodbye message popup
 */
const initNewsLetterPopin = () => {
    if (popupTrigger === 0 || popupTrigger === 1) {
        const $newsletterAsset = $(".js-newsletter-popin");

        if ($newsletterAsset.length) {
            const popupGroup = $newsletterAsset.data("modal-group");

            if (popupGroup) {
                const allocatedPopupVariable = getNewsletterCookie();

                if ($newsletterAsset.length && !allocatedPopupVariable) {
                    if (popupTrigger === 0) {
                        $body.one("mouseleave", () => {
                            if (!$body.hasClass("modal-open")) {
                                getNewsletterPopin($newsletterAsset);
                            }
                        });
                    } else {
                        setTimeout(() => {
                            if (!$body.hasClass("modal-open")) {
                                getNewsletterPopin($newsletterAsset);
                            }
                        }, seconds);
                    }
                }
            }
        }
    }
};

/**
 * Retrieves the newsletter popin content and displays it as a modal
 * @param {jQuery} element - the element triggering the popin
 */
function getNewsletterPopin(element) {
    const contentAssetUrl = element.data("modal-content");
    const contentAssetGroup = element.data("modal-group");

    if (contentAssetUrl) {
        $.ajax({
            type: "GET",
            url: contentAssetUrl,
            dataType: "json",
            success: function (data) {
                if (data.modalTemplate) {
                    let $modal = $(".modal");

                    if ($modal.length) {
                        $modal.modal("hide");
                    }

                    $("body").append(data.modalTemplate);

                    const $assetPopup = $("#newsletter-popin-modal");
                    const $popinImage = $assetPopup.find(".js-newsletter-popin-image");

                    $popinImage.on("load", function () {
                        setPopinHeightToImageHeight();
                    });

                    lazyLoading.manageLazyLoadingFeature();

                    $assetPopup.modal("show");

                    $(document).on("shown.bs.modal", $assetPopup, () => {
                        setTimeout(() =>{
                            setPopinHeightToImageHeight();
                            $assetPopup.find(".modal-dialog").removeClass("invisible");
                            initFormEvents();
                        }, 50);
                    });

                    $(document).on("hide.bs.modal", $assetPopup, () => {
                        $assetPopup.remove();
                        document.cookie = contentAssetGroup + "PopupShown=true; path=/";
                    });

                    $(window).on("resize", debounce(function () {
                        setPopinHeightToImageHeight();
                    }, 500));
                }
            }
        });
    }
}

/**
 * Sets the height of the popin to match the height of the image
 */
function setPopinHeightToImageHeight() {
    const $assetPopup = $("#newsletter-popin-modal");
    const $popinImage = $assetPopup.find(".js-newsletter-popin-image");

    if (window.mqRespond.status.mdUp|| window.mqRespond.status.mdOnly) {
        $assetPopup.find(".js-newsletter-container").css("max-height", `${$popinImage.height()}px`);
    } else {
        $assetPopup.find(".js-newsletter-container").css("max-height", "90vh");
    }
}

/**
 * Verifies the email address entered in the newsletter form
 * @returns {void}
 */
function verifyEmailAddress() {
    $(".m-newsletter-popin form.newsletter #newsletter_email").on("blur", function () {
        var form = $("form.newsletter");
        var url = form.attr("data-email-verification-url");
        if (!url || url.length === 0) {
            return;
        }

        var formGroup = form.find(".newsletter-password");
        var formHint = form.find(".newsletter-password-hint");
        var forgotPasswordLink = form.find(".forgot-password");

        if (!this.value || (this.value.length === 0)) {
            formGroup.addClass("d-none").removeClass("required");
            formGroup.find("input").removeAttr("required").removeAttr("aria-required").val("");
            formHint.addClass("d-none");
            forgotPasswordLink.addClass("d-none");

            return;
        }

        $.ajax({
            url: form.attr("data-email-verification-url"),
            type: "post",
            data: form.serialize(),
            success: function (data) {
                if (data.profileExists) {
                    formGroup.removeClass("d-none").addClass("required");
                    formGroup.find("input").attr("required", "required").attr("aria-required", true);
                    formHint.removeClass("d-none");
                    forgotPasswordLink.removeClass("d-none");
                } else {
                    formGroup.addClass("d-none").removeClass("required");
                    formGroup.find("input").removeAttr("required").removeAttr("aria-required").val("");
                    formHint.addClass("d-none");
                    forgotPasswordLink.addClass("d-none");
                }
            }
        });
    });
}

/**
 * Submits the newsletter form and handles the response
 */
function submitNewsletter() {
    $(".m-newsletter-popin form.newsletter").submit(function (e) {
        e.preventDefault();

        var form = $(this);
        var firstNameElement = form.find("#newsletter_firstName");
        var lastNameElement = form.find("#newsletter_lastName");
        var jpFirstNameElement = form.find("#newsletter_katakanaFirstName");
        var jpLastNameElement = form.find("#newsletter_katakanaLastName");
        var firstName = firstNameElement.val().trim();
        var lastName = lastNameElement.val().trim();
        var isFirstNameValid = newsletterValidation.isValidName(firstName);
        var isLastNameValid = newsletterValidation.isValidName(lastName);

        var isKataKanaInvalid = false;
        var jpFirstName, jpLastName, isJPFirstNameValid, isJPLastNameValid;

        if (jpFirstNameElement && jpFirstNameElement.length > 0 && jpLastNameElement && jpLastNameElement.length > 0) {
            jpFirstName = jpFirstNameElement.val().trim();
            jpLastName = jpLastNameElement.val().trim();
            isJPFirstNameValid = newsletterValidation.isValidKatakanaName(jpFirstName);
            isJPLastNameValid = newsletterValidation.isValidKatakanaName(jpLastName);
            isKataKanaInvalid = !isJPFirstNameValid || !isJPLastNameValid;
            isFirstNameValid = newsletterValidation.isValidKanjiName(firstName);
            isLastNameValid = newsletterValidation.isValidKanjiName(lastName);
        }

        if (!isFirstNameValid || !isLastNameValid || isKataKanaInvalid) {
            var invalidErrorMessage = $("#invalid-input-error-message").val() || "Invalid input provided.";

            // Determine which field is invalid and show feedback
            if (!isFirstNameValid) {
                firstNameElement.addClass("is-invalid");
                firstNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                setClearButtonPosition(firstNameElement);
            }
            if (!isLastNameValid) {
                lastNameElement.addClass("is-invalid");
                lastNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                setClearButtonPosition(lastNameElement);
            }
            if (isKataKanaInvalid) {
                if (!isJPFirstNameValid) {
                    jpFirstNameElement.addClass("is-invalid");
                    jpFirstNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                    setClearButtonPosition(jpFirstNameElement);
                }
                if (!isJPLastNameValid) {
                    jpLastNameElement.addClass("is-invalid");
                    jpLastNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                    setClearButtonPosition(jpLastNameElement);
                }
            }

            return;
        }

        var checkboxValidation = checkboxesGroupValidation();
        if (!checkboxValidation) {
            var url = form.attr("action");
            form.spinner().start();
            googleRecaptcha.getRecaptchaResponse().then(function () {
                $.ajax({
                    url: url,
                    type: "post",
                    data: form.serialize(),
                    success: function (data) {
                        form.spinner().stop();
                        if (!data.success) {
                            formValidation(form, data);
                        } else {
                            if ($("#form-sport-preferences-error").html().length == 0) {
                                $(".js-newsletter-confirmation").html(data.renderingTemplate);
                            }
                            document.cookie = $(".js-newsletter-popin").data("modal-group") + "PopupShown=true; path=/";
                        }
                    },
                    error: function () {
                        form.spinner().stop();
                    }
                });
            }).catch(function () {
                form.spinner().stop();
                var errorMessageText = $("#google-recaptcha-main").data("error-register");
                recaptchaErrorNotification($("#newsletter-popin-modal").find(".error-newsletter-recaptcha"), errorMessageText);
            });
        }
    });
}

/**
 * Initializes form events
 * @returns {void}
 */
function initFormEvents() {
    fieldRequirements();
    initializeCheckboxAccessibility(".m-newsletter-popin");
    verifyEmailAddress();
    submitNewsletter();
    passwordShow();
    processInclude(require("../components/clientSideValidation"));
    addressHelpers.methods.syncKanjiAndKatakana();
}

module.exports = initNewsLetterPopin;
